import { Model } from '@vuex-orm/core';
import Zaui from '@/include/api';

export default class Agent extends Model {
  static entity = 'agents';

  static fields() {
    return {
      id: this.number(),
      autoLogin: this.boolean(),
      username: this.string(),
      password: this.string(), // only used for POST
      email: this.string(),
      phone: this.string(),
      company: this.string(),
      isWholesaleRateType: this.boolean(),
      firstName: this.string(),
      lastName: this.string(),
      expiryDate: this.string(),
      bookings: this.attr()
    };
  }

  static active() {
    return Agent.query().first();
  }

  static load() {
    return Zaui.agent.load().then(data => {
      if(data) {
        Agent.create({ data });
      }

      return data;
    });
  }

  static login(username, password) {
    return Zaui.agent.login(username, password).then(data => {
      Agent.create({ data });
    });
  }

  static addAffiliate(id) {
    return Zaui.agent.addAffiliate(id);
  }

  static logout() {
    return Zaui.agent.logout().then(data => {
      Agent.deleteAll();
    });
  }

  static update(agentModel, newPassword1 = "", newPassword2 = "") {
    return Zaui.agent.update(agentModel, newPassword1, newPassword2).then(response => {
      const data = response.agent;
      Agent.create({ data });

      return response.result;
    });
  }
}